// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-notice {
  font-size: 16px;
  padding: 16px;
}
@media all and (min-width: 375px) {
  .mobile-notice {
    font-size: 18px;
    padding: 32px;
  }
}
@media all and (min-width: 768px) {
  .mobile-notice {
    font-size: 24px;
    padding: 40px;
  }
}
@media all and (min-width: 1024px) {
  .mobile-notice {
    font-size: 32px;
    padding: 48px;
  }
}
.mobile-notice__header {
  font-size: 18px;
  text-align: center;
}
@media all and (min-width: 375px) {
  .mobile-notice__header {
    font-size: 24px;
  }
}
@media all and (min-width: 768px) {
  .mobile-notice__header {
    font-size: 32px;
  }
}
@media all and (min-width: 1024px) {
  .mobile-notice__header {
    font-size: 48px;
  }
}
.mobile-notice__emoji {
  font-size: 24px;
}
@media all and (min-width: 375px) {
  .mobile-notice__emoji {
    font-size: 32px;
  }
}
@media all and (min-width: 768px) {
  .mobile-notice__emoji {
    font-size: 48px;
  }
}
@media all and (min-width: 1024px) {
  .mobile-notice__emoji {
    font-size: 64px;
  }
}
.mobile-notice__centered {
  text-align: center;
}
.mobile-notice__small-padding {
  width: 100%;
}
.mobile-notice > :not(:last-child) {
  margin-bottom: 16px;
}
@media all and (min-width: 375px) {
  .mobile-notice > :not(:last-child) {
    margin-bottom: 32px;
  }
}
@media all and (min-width: 768px) {
  .mobile-notice > :not(:last-child) {
    margin-bottom: 40px;
  }
}
@media all and (min-width: 1024px) {
  .mobile-notice > :not(:last-child) {
    margin-bottom: 48px;
  }
}
.mobile-notice__small-padding > :not(:last-child) {
  margin-bottom: 4px;
}
@media all and (min-width: 375px) {
  .mobile-notice__small-padding > :not(:last-child) {
    margin-bottom: 8px;
  }
}
@media all and (min-width: 768px) {
  .mobile-notice__small-padding > :not(:last-child) {
    margin-bottom: 16px;
  }
}
@media all and (min-width: 1024px) {
  .mobile-notice__small-padding > :not(:last-child) {
    margin-bottom: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/components/mobile-notice/MobileNotice.less"],"names":[],"mappings":"AASA;EACE,eAAA;EACA,aAAA;AARF;AAUE;EAAA;IACE,eAAA;IACA,aAAA;EAPF;AACF;AASE;EAAA;IACE,eAAA;IACA,aAAA;EANF;AACF;AAQE;EAAA;IACE,eAAA;IACA,aAAA;EALF;AACF;AAOE;EACE,eAAA;EACA,kBAAA;AALJ;AAOI;EAAA;IACE,eAAA;EAJJ;AACF;AAMI;EAAA;IACE,eAAA;EAHJ;AACF;AAKI;EAAA;IACE,eAAA;EAFJ;AACF;AAKE;EACE,eAAA;AAHJ;AAKI;EAAA;IACE,eAAA;EAFJ;AACF;AAII;EAAA;IACE,eAAA;EADJ;AACF;AAGI;EAAA;IACE,eAAA;EAAJ;AACF;AAGE;EACE,kBAAA;AADJ;AAIE;EACE,WAAA;AAFJ;AAKE;EACE,mBAAA;AAHJ;AAKI;EAAA;IACE,mBAAA;EAFJ;AACF;AAII;EAAA;IACE,mBAAA;EADJ;AACF;AAGI;EAAA;IACE,mBAAA;EAAJ;AACF;AAGE;EACE,kBAAA;AADJ;AAGI;EAAA;IACE,kBAAA;EAAJ;AACF;AAEI;EAAA;IACE,mBAAA;EACJ;AACF;AACI;EAAA;IACE,mBAAA;EAEJ;AACF","sourcesContent":["@break1: 375px;\n@break2: 768px;\n@break3: 1024px;\n\n@p1: 16px;\n@p2: 32px;\n@p3: 40px;\n@p4: 48px;\n\n.mobile-notice {\n  font-size: 16px;\n  padding: @p1;\n\n  @media all and (min-width: @break1) {\n    font-size: 18px;\n    padding: @p2;\n  }\n\n  @media all and (min-width: @break2) {\n    font-size: 24px;\n    padding: @p3;\n  }\n\n  @media all and (min-width: @break3) {\n    font-size: 32px;\n    padding: @p4;\n  }\n\n  &__header {\n    font-size: 18px;\n    text-align: center;\n\n    @media all and (min-width: @break1) {\n      font-size: 24px;\n    }\n\n    @media all and (min-width: @break2) {\n      font-size: 32px;\n    }\n\n    @media all and (min-width: @break3) {\n      font-size: 48px;\n    }\n  }\n\n  &__emoji {\n    font-size: 24px;\n\n    @media all and (min-width: @break1) {\n      font-size: 32px;\n    }\n\n    @media all and (min-width: @break2) {\n      font-size: 48px;\n    }\n\n    @media all and (min-width: @break3) {\n      font-size: 64px;\n    }\n  }\n\n  &__centered {\n    text-align: center;\n  }\n\n  &__small-padding {\n    width: 100%;\n  }\n\n  & > :not(:last-child) {\n    margin-bottom: @p1;\n\n    @media all and (min-width: @break1) {\n      margin-bottom: @p2;\n    }\n\n    @media all and (min-width: @break2) {\n      margin-bottom: @p3;\n    }\n\n    @media all and (min-width: @break3) {\n      margin-bottom: @p4;\n    }\n  }\n\n  &__small-padding > :not(:last-child) {\n    margin-bottom: 4px;\n\n    @media all and (min-width: @break1) {\n      margin-bottom: 8px;\n    }\n\n    @media all and (min-width: @break2) {\n      margin-bottom: 16px;\n    }\n\n    @media all and (min-width: @break3) {\n      margin-bottom: 24px;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
